<template lang="pug">
pr-wrapper.sidepane.animated(fs, bg, bgo=".5", :zi="index", v-visible="activated")
  pr-wrapper.sidepane-container.animated.d-flex.flex-column.justify-content-center(fs, bg, zi="1", :class="position")
    .sidepane-header.px-5.pt-5.pb-4(ref="header")
      .d-flex.flex-column
        pr-subtitle(size="medium") {{ payload.title }}
        pr-text.mt-2.small.text-muted(v-show="payload.detail") {{ payload.detail }}
    .sidepane-scope.overflow-hidden(
      v-nv:scope="'sidepane'",
      data-scroll="center",
      nv-sleep-protect,
      nv-exit-protect,
      @nv-exit="close",
      @nv-back="close",
      ref="scope"
    )
      .scroll-container.position-relative.px-5.py-2(ref="body")
        .option.themed.scale-sm.text-muted.py-3.d-flex.align-items-center(
          v-nv="option.selected",
          @nv-enter="select(option.key)",
          v-for="option in payload.data",
          :key="option.key",
          :class="[option.image ? 'px-3' : 'px-5']"
        ) 
          imagec.mr-3(:data-link="option.image", :src="option.image", small-placeholder, v-if="option.type === 'image'")
          icon.fa-2x.mr-3(:icon="option.image", :type="option.type", v-else-if="option.type && option.type.includes('icon')") 
          .title
            pr-text(weight="semibold")(v-html="option.value")
            pr-text.small(v-if="option.subvalue", v-html="option.subvalue") 
    .sidepane-footer.p-3(ref="footer")
</template>

<script>
export default {
  name: "sidepane",
  data() {
    return {
      activated: false,
      payload: {},
      lastNavigation: null,
      index: "0"
    }
  },
  computed: {
    position() {
      if (!this.payload.options || !this.payload.options.position) return false

      return {
        left: this.payload.options.position === "left",
        right: this.payload.options.position === "right",
        activated: this.activated
      }
    }
  },
  watch: {
    activated(nval) {
      this.$emit("activate", { name: this.$options.name, state: nval })
      this.index = nval ? "103" : "0"
    }
  },
  mounted() {
    _$.vue.$on("sidepane", this.activate)
    _$.vue.$on("beforeRoute", () => this.close("abort"))
  },
  methods: {
    async activate(payload) {
      if (!payload) return this.close("abort")
      else if (payload === "skip") return this.close()
      if (!this.validatePayload(payload)) return false
      if (this.activated) this.payload.reject()

      this.payload = payload

      await this.$nextTick()

      this.lastNavigation = this.lastNavigation || { current: _$.nav.getCurrentScope(), prev: _$.nav.getPrevScope() }

      if (this.$refs.header.offsetHeight + this.$refs.body.offsetHeight + this.$refs.footer.offsetHeight > window.innerHeight)
        this.$refs.scope.style.maxHeight = window.innerHeight - this.$refs.header.offsetHeight - this.$refs.footer.offsetHeight + "px"
      else this.$refs.scope.style.maxHeight = "none"

      await _$.nav.sync("sidepane", true)
      this.activated = true
    },
    validatePayload(payload) {
      let validate = true

      if (typeof payload !== "object") validate = false
      else if (!payload.title || !payload.data || !payload.options || !payload.resolve || !payload.reject) validate = false
      else if (!Array.isArray(payload.data)) validate = false
      else if (typeof payload.resolve !== "function") validate = false
      else if (typeof payload.reject !== "function") validate = false

      if (!validate && typeof payload === "object" && payload.reject) payload.reject()

      return validate
    },
    select(result) {
      this.close(true, result)
    },
    close(reason, resolve) {
      if (!this.activated) return false

      if (this.lastNavigation && reason !== "abort") {
        if (this.lastNavigation.current) _$.nav.changeScope(this.lastNavigation.current.name)
        _$.nav._prevScope = this.lastNavigation.prev
      }

      this.lastNavigation = null
      this.activated = false

      if (resolve) this.payload.resolve(resolve)
      else this.payload.reject()

      this.payload = {}

      if (resolve) return resolve
      else return false
    }
  }
}
</script>

<style lang="scss" scoped>
.sidepane-container {
  width: 400px;
  box-shadow: 10px 0px 15px 2px rgba(0, 0, 0, 0.5);

  &.left {
    left: -415px;
    right: auto !important;
    &.activated {
      left: 0;
    }
  }

  &.right {
    box-shadow: -10px 0px 15px 2px rgba(0, 0, 0, 0.5);
    right: -415px;
    left: auto !important;
    &.activated {
      right: 0;
    }
  }

  .sidepane-header {
    position: relative;
    z-index: 1;
  }

  .sidepane-scope {
    max-height: 0;

    .option {
      display: flex;
      align-items: center;
      .imagec {
        min-width: 50px;
        min-height: 50px;
        max-width: 50px;
        max-height: 50px;
        overflow: hidden;
      }
      .icon {
        display: flex;
        width: 50px;
        height: 50px;
        align-items: center;
        justify-content: center;
      }
      &.nv-el-current {
        border-radius: 5px;
      }
    }
  }
}
</style>
